<script lang="ts">
	/**
	 * Shared Home-list skeleton grid for mount defer and Dev Modal force mode.
	 * Uses the real card components with `skeleton` — see Lists/skeleton-loading.md.
	 */
	import {
		AdvancedCardV2,
		CardGrid,
		DashControlWidget,
		DashDeviceWidget,
		ListMenuCardV2,
	} from '@Shelly/shelly-design-system';
	import { LIST_SKELETON_COUNT } from 'src/stores/features/dev/force-list-skeleton';

	export let count = LIST_SKELETON_COUNT;
	/** Which DS card footprint to reserve. */
	export let variant: 'list-menu' | 'advanced' | 'device-widget' | 'control-widget' = 'list-menu';
	export let listMenuType: 'compact' | 'regular' | 'extended' = 'extended';
	export let xl = 350;
	export let lg = 290;
	export let sm = 270;
	export let className = '';
	export { className as class };

	$: slots = Array.from({ length: count }, (_, i) => i);

	function widgetSkeletonVariant(index: number): 'tap' | 'button' {
		return index % 2 === 0 ? 'tap' : 'button';
	}
</script>

<CardGrid
	class={className}
	editMode={false}
	{xl}
	{lg}
	{sm}
	aria-busy="true"
	aria-hidden="true"
	{...$$restProps}
>
	{#each slots as slot (slot)}
		{#if variant === 'advanced'}
			<AdvancedCardV2 skeleton />
		{:else if variant === 'device-widget'}
			<DashDeviceWidget skeleton skeletonVariant={widgetSkeletonVariant(slot)} />
		{:else if variant === 'control-widget'}
			<DashControlWidget skeleton skeletonVariant={widgetSkeletonVariant(slot)} />
		{:else}
			<ListMenuCardV2 skeleton type={listMenuType} editMode={false} selected={false} />
		{/if}
	{/each}
</CardGrid>
